import {BreadcrumbMeta, ContentPageMetaResolver, Page} from '@spartacus/core';
import {Observable, of} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable()
export class OspSearchResultPageMetaResolver extends ContentPageMetaResolver {
    pageTemplate = 'sanofiContentSearchPageTemplate';

    resolveBreadcrumbs(): Observable<BreadcrumbMeta[]> {
        let breadcrumbs: Observable<BreadcrumbMeta[]> = of([]);
        breadcrumbs = of([
            { label: 'Home', link: '/' },
            { label: 'Tools & Resources', link: '/toolsandresources' },
            { label: 'Help Center', link: '/help-center/all' },
            { label: 'Search Results', link: ''}
        ]);
        return breadcrumbs;
    }

    getScore(page: Page): number {
        let score = 0;
        if (this.pageTemplate) {
            score += page.template === this.pageTemplate ? 100 : -1;
        }
        return score;
    }
}
